import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/ProfilePage";
import Skills from "./pages/Skills";
import AvatarCustomization from "./pages/AvatarCustomization";
import Redeem from "./pages/Redeem";
import Admin from "./pages/Admin";
import TermsModal from "./components/TermsModal";
import { appThemeTokens } from "./theme";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import Chat from "./pages/Chat";
import Community from "./pages/Community";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: appThemeTokens,
        components: {
          Layout: {
            bodyBg: appThemeTokens.colorBgLayout,
            headerBg: "transparent",
            siderBg: "transparent",
          },
          Card: {
            colorBgContainer: appThemeTokens.colorBgContainer,
          },
        },
      }}
    >
      <AuthProvider>
        <TermsModal />
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route path="/comunidad" element={<PrivateRoute><Community /></PrivateRoute>} />
            <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
            <Route
              path="/skills"
              element={
                <PrivateRoute>
                  <Skills />
                </PrivateRoute>
              }
            />
            <Route
              path="/avatar"
              element={
                <PrivateRoute>
                  <AvatarCustomization />
                </PrivateRoute>
              }
            />
            <Route
              path="/redeem"
              element={
                <PrivateRoute>
                  <Redeem />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                </PrivateRoute>
              }
            />
            <Route
              path="/main"
              element={<Navigate to="/dashboard" replace />}
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
